import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function milestoneTemplateIdsNeedingUpdateReducer(state = initialState.milestoneTemplateIdsNeedingUpdate, action) {

    const mergeIdIn = (milestoneTemplateIds, id) => {
        return milestoneTemplateIds.filter(o => o !== id)
            .concat(id);
    }

    switch (action.type) {
        case types.LOAD_MILESTONETEMPLATE_SUCCESS:
            return state.filter(s => s !== action.milestoneTemplate.id);
        case types.UPDATED_MILESTONETEMPLATE_INCOMING:
            return mergeIdIn(state, action.payload);
        case types.UPDATED_MILESTONETEMPLATEENTRY_INCOMING:
        case types.DELETED_MILESTONETEMPLATEENTRY_INCOMING:
            return mergeIdIn(state, action.payload.milestoneTemplateId);
        case types.UPDATED_MILESTONETEMPLATEENTRY_SUCCESS:   
        case types.DELETED_MILESTONETEMPLATEENTRY:
            return mergeIdIn(state,action.milestoneTemplateEntry.milestoneTemplateId);
        default:
            return state;
    }
}